import axios, { type AxiosResponse } from 'axios';

import { logToSentry } from '@jsmdg/react-fragment-scripts/fragment';
import { type Reviews } from '../../shared/reviews';

export const fetchProductReviewsFromUrl = async (productId: string): Promise<Reviews | null> => {
    try {
        const { data }: AxiosResponse<Reviews> = await axios.get('api/reviews', {
            params: {
                productId,
            },
        });

        return data;
    } catch (error: unknown) {
        logToSentry(error as Error);

        return null;
    }
};
